import smeImage from "../../res/images/sme.jpg";
import ftacvImage from "../../res/images/ftacv.jpg";
import burrianaImage from "../../res/images/burriana.jpg";
import relevoImage from "../../res/images/relevo.png";
import alfonsoImage from "../../res/images/trinidad_alfonso.png";
import cvEsportImage from "../../res/images/cv_esport.png";

export type LinkFooterType = {
    src: string,
    alt: string,
    link: string,
}

class FooterLinks {
    public static SME: string = 'http://sme.burriana.es/';
    public static FTACV: string = 'https://www.ftacv.org/';
    public static BURRIANA: string = 'http://www.burriana.es/';
    public static RELEVO: string = 'https://www.paralimpicos.es/relevo-paralimpico';
    public static TRINIDAD_ALFONSO: string = 'https://fundaciontrinidadalfonso.org/';
    public static CV_ESPORT: string = 'https://www.comunitatdelesport.com/';
}

export default class FooterService {

    static getFooterLinks(): LinkFooterType[] {
        return [{
            src: smeImage,
            alt: 'SME',
            link: FooterLinks.SME
        }, {
            src: ftacvImage,
            alt: 'ftacv',
            link: FooterLinks.FTACV
        }, {
            src: burrianaImage,
            alt: 'ayto. burriana',
            link: FooterLinks.BURRIANA
        }, {
            src: relevoImage,
            alt: 'relevo',
            link: FooterLinks.RELEVO
        }, {
            src: alfonsoImage,
            alt: 'trinidad alfonso',
            link: FooterLinks.TRINIDAD_ALFONSO
        }, {
            src: cvEsportImage,
            alt: 'Comunitat Valenciana esport',
            link: FooterLinks.CV_ESPORT
        }
        ]
    }
}